"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var BaseCollectionQuery_1 = require("./BaseCollectionQuery");
var Query_1 = require("./Query");
var WordpressGlobalSearchContentQuery = /** @class */ (function (_super) {
    __extends(WordpressGlobalSearchContentQuery, _super);
    function WordpressGlobalSearchContentQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WordpressGlobalSearchContentQuery.prototype.initialize = function (executionOptions) { };
    WordpressGlobalSearchContentQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, code = _a.code, key = _a.key, collectionItemConditional = _a.collectionItemConditional, sort = _a.sort, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ code: code,
            key: key,
            collectionItemConditional: collectionItemConditional,
            sort: sort }, (options.wordpressGlobalSearch || {}));
    };
    WordpressGlobalSearchContentQuery.prototype.getRawValue = function (executionOptions) {
        var _this = this;
        var sort = this.options.sort;
        var posts = this.getPosts(executionOptions);
        if (sort) {
            posts = this.applySort(posts, sort, undefined, executionOptions.inputs);
        }
        return posts && posts.map(function (post) { return _this.getPost(executionOptions, post); });
    };
    WordpressGlobalSearchContentQuery.prototype.getPosts = function (executionOptions) {
        var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
        var _a = this.options.collectionItemConditional, collectionItemConditional = _a === void 0 ? { conditions: [] } : _a;
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        var articles = context.wordpressGlobalSearch.articles;
        if (articles) {
            var collectionItems = articles.filter(function (item) {
                return conditionalHelper.matches(item, collectionItemConditional, executionOptions);
            });
            return collectionItems;
        }
        return;
    };
    WordpressGlobalSearchContentQuery.prototype.getPost = function (executionOptions, post) {
        var _a = this.options, code = _a.code, key = _a.key;
        return this.getPostValue(executionOptions, post, code, key);
    };
    WordpressGlobalSearchContentQuery.prototype.getPostValue = function (executionOptions, post, code, key) {
        if (code === void 0) { code = null; }
        if (key === void 0) { key = null; }
        if (post) {
            if (code && key) {
                var postMeta = post[code];
                var postMetaByKey = postMeta[key];
                if (postMetaByKey) {
                    return postMetaByKey;
                }
            }
            if (code) {
                return post[code];
            }
        }
        return;
    };
    return WordpressGlobalSearchContentQuery;
}(BaseCollectionQuery_1.BaseCollectionQuery));
exports.WordpressGlobalSearchContentQuery = WordpressGlobalSearchContentQuery;
//# sourceMappingURL=WordpressGlobalSearchContentQuery.js.map